import Axios from 'axios'
import i18next from 'i18next'
import { availableLanguages } from '../i18nextConf'

const axios = Axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
    headers: {
        'X-Requested-With': 'XMLHttpRequest'
    },
    withCredentials: true,
    timeout: 120000
})

axios.interceptors.request.use(
    config => {
        const lang = i18next.resolvedLanguage
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

        config.headers['Preferred-Language'] = availableLanguages.includes(lang) ? lang : 'en'
        config.headers['X-Timezone'] = timezone ?? 'UTC'

        return config
    },

    error => Promise.reject(error),
)


export default axios
